import React from "react";
import "./Causes.css";
import mcm from '../Assets/mcm.png'
import mess from '../Assets/messfund.png'
import hostel from '../Assets/hostel.png'

function Causes() {
  return (
    <>
      <div className="cause-container" id="idcauses">
        <div className="container">
          <div className="row">
            <h2 className="cause-heading">Causes to support as a class</h2>
            <div className="col-lg-4 col-md-6 col-sm-12 text-center">
              <div className="donate">
                  <div className="card-body">
                    <h4 className="card-title">MCM Scholarship</h4>
                    <img className="cause-images" src={mcm} alt="cause-img1"/>
                    <p className="card-text">
                    The MCM Scholarship is dedicated to supporting deserving students whose parental annual income is less than ₹5 lakhs. The education that shaped our futures is a gift that should be passed on, empowering the next generation to achieve their dreams and contribute to the world.
                    </p>
                    <a href="https://joyofgiving.alumni.iitm.ac.in/projects/students-project/merit-cum-means-scholarship-2024-25" className="btn btn-default donate-btn" target="_blank" rel="noreferrer">
                      Donate now
                    </a>
                  </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12 text-center">
              <div className="donate">
                  <div className="card-body">
                    <h4 className="card-title">Student Mess Fund</h4>
                    <img className="cause-images" src={mess} alt="cause-img2"/>
                    <p className="card-text">
                    The Student Mess Fund ensures that every student has access to the wholesome meals they need to lead a balanced and mindful life. By supporting the Student Mess Fund, you're investing in the well-being and academic success of our students.
                    </p>
                    <a href="https://joyofgiving.alumni.iitm.ac.in/projects/general-fund/student-mess-fund" className="btn btn-default donate-btn" target="_blank" rel="noreferrer">
                      Donate now
                    </a>
                  </div>
                </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12 text-center">
              <div className="donate">
                  <div className="card-body">
                    <h4 className="card-title">Hostel Renovation</h4>
                    <img className="cause-images" src={hostel} alt="cause-img3"/>
                    <p className="card-text">
                    Food, education, and shelter—these are the cornerstones of a meaningful life. For IITM students, a well-maintained place to stay isn't just a basic need; it's where they grow, learn, and build their future. Together, let's give our juniors the best foundation for success. 
                    </p>
                    <a href="https://joyofgiving.alumni.iitm.ac.in/search-projects?q=keepitflowing" className="btn btn-default donate-btn" target="_blank" rel="noreferrer">
                      Donate now
                    </a>
                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default Causes;